import { render, staticRenderFns } from "./SupplierStockMindestpreiseComponent.vue?vue&type=template&id=3375c752&"
import script from "./SupplierStockMindestpreiseComponent.vue?vue&type=script&lang=js&"
export * from "./SupplierStockMindestpreiseComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports